import { query, revalidate } from "@solidjs/router";
import { fetchStoragePath } from "./firebaseStorage";

export const getTopic = query(async (topic) => {
  return await fetchStoragePath(`/topics/${encodeURIComponent(topic)}.json`);
}, "getTopic");

export function revalidateTopic(topic) {
  return revalidate(getTopic.keyFor(topic));
}

export const getAllTopics = query(async () => {
  return await fetchStoragePath("/all-topics.json");
}, "getAllTopics");

export function revalidateAllTopics() {
  return revalidate(getAllTopics.keyFor());
}
